import { connect } from 'react-redux';
import Timeline from '../components/Timeline/Timeline';
import { getExecutiveListByExecutivePersonId } from '../redux/actions/ExecutiveList';
import { getUser } from '../redux/actions/AccountSetting';
import { goBack, push } from 'react-router-redux';
import { getAddressById } from '../redux/actions/AddressDetail';
import * as actions from '../redux/actions/Timeline';

const mapStateToProps = (state) => {
  const isExeTimeline = state.router.location.pathname.includes("executive-list");
  return {
    isExeTimeline: isExeTimeline,
    user: state.accountSetting.user,
    // キーマン情報
    keymanItem: isExeTimeline ? state.executiveDetail.item : state.addressDetail.contact,
    isLoadingKeymanItem: isExeTimeline ? state.executiveDetail.isLoading : state.addressDetail.isLoading,
    // タイムラインステータス
    statuses: state.timeline.statuses.toIndexedSeq().toArray(),
    isLoadingStatuses: state.timeline.isLoadingStatuses,
    // その他
    message: state.timeline.message,
    shortMessage: state.timeline.shortMessage,
    errorMessage: state.timeline.errorMessage,
    routerInfo: state.router.location,
  };
};

const mapDispatchToProps = dispatch => ({
  getUserInfo() {
    dispatch(getUser());
  },

  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  // 自社リストの場合のキーマン情報
  getAddressById(id) {
    dispatch(getAddressById(id, { "show_deleted": 1 }));
  },

  // キーマンデータベースの場合のキーマン情報
  getExecutiveListByExecutivePersonId(id, data) {
    dispatch(getExecutiveListByExecutivePersonId(id, data))
  },

  // タイムラインの一覧を取得
  getTimelineStatus(id, data) {
    dispatch(actions.getTimelineStatus(id, {
      ...data,
      with_user: true,
      with_ownership_user: true,
      with_letter_order: true,
      with_follow_order: true,
      with_order: true,
    }));
  },

  // タイムラインを保存
  postTimelineStatus(id, data) {
    dispatch(actions.postTimelineStatus(id, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);



// WEBPACK FOOTER //
// ./src/containers/Timeline.js